
/* eslint-disable import/no-cycle */
import { setBreadcrumb } from './index';
import ChangePIC from '../views/change-pic/ChangePic.vue';
import Parent from '../views/Parent.vue';

const ChangePicRoute = {
  path: '/change-pic',
  meta: {
    title: 'BNI QRIS - Change PIC',
    appBarTitle: 'Change PIC',
  },
  component: Parent,
  children: [
    {
      path: '',
      name: 'ChangePIC',
      meta: {
        title: 'BNI QRIS - Change PIC',
        appBarTitle: 'Change PIC',
        breadcrumbs: () => [
          setBreadcrumb('Change PIC', '/change-pic', true),
          setBreadcrumb('List Merchant', '/change-pic'),
        ],
      },
      component: ChangePIC,
    },
  ],
};

export default ChangePicRoute;